import { useCurrentPatientFile } from '../_components/patient-file.provider'
import { useEffect, useState } from 'react'
import { useLocalizedNavigate } from 'src/hooks/use-localized-navigate'
import { useParams } from 'react-router-dom'
import Appointments from './_components/appointments.component'
import Timeline from './_components/timeline.component'
import OtherPatientInformation from './_components/other-patient-information.component'
import PatientForms from './_components/patient-forms.component'
import PatientFollowupActionBar from './_components/patient-followup-action-bar.component'
import { TPatientForm } from 'src/types/form'

export const PatientFilePatientFollowupPage = () => {
  const navigate = useLocalizedNavigate()
  const params = useParams()
  const patientFollowupId = Number(params.patientFollowupId)
  const { patient, patientTimeline, currentPatientFollowup, patientAllVariables } = useCurrentPatientFile()
  const currentFollowup = currentPatientFollowup?.Followup
  const [patientFormsToShow, setPatientFormsToShow] = useState<TPatientForm[]>([])

  useEffect(() => {
    if (!currentFollowup?.id) {
      navigate(`/${params.projectId}/medical/patients/${patient.id}/add-patient-followup`, { replace: true })
    }
  }, [currentFollowup?.id, navigate, params.projectId, patient.id])

  useEffect(() => {
    if (patientAllVariables?.patientForms?.length > 0) {
      const sortedPatientFormsToShow = patientAllVariables?.patientForms.sort(
        (form1, form2) => new Date(form2.createdAt).getTime() - new Date(form1.createdAt).getTime(),
      )
      setPatientFormsToShow(sortedPatientFormsToShow)
    }
  }, [patientAllVariables?.patientForms, patientFollowupId])

  const patientMedEventsToShow =
    patient.PatientMedEvents?.filter(
      (patientMedEvent) => patientMedEvent.PatientFollowupId === patientFollowupId,
    ) || []

  if (!currentFollowup?.id || !currentPatientFollowup) return <div className="loading" />

  return (
    <div className="c-overflow-y-auto">
      <PatientFollowupActionBar patient={patient} currentPatientFollowup={currentPatientFollowup} />
      <div className="c-flex c-mx-auto c-gap-6 c-min-h-0 c-pb-6">
        <div className="c-w-full c-flex c-flex-col c-gap-4">
          <Appointments
            currentPatientFollowup={currentPatientFollowup}
            patientMedEvents={patientMedEventsToShow}
            patientMedAlerts={patient.PatientMedAlerts || []}
            currentFollowup={currentFollowup}
            patientFollowupId={patientFollowupId}
          />
          <PatientForms
            patient={patient}
            patientForms={patientFormsToShow}
            currentFollowupId={currentFollowup.id}
            currentPatientFollowupId={patientFollowupId}
          />
          <OtherPatientInformation
            patientMedAlerts={patient.PatientMedAlerts || []}
            patientForms={patientFormsToShow}
          />
        </div>
        <Timeline key={patientFollowupId} patient={patient} patientTimeline={patientTimeline} />
      </div>
    </div>
  )
}
